import type { BrandId, LayoutType } from "@ifa/utils";

import { toAntdMobileTheme } from "../adapters/antd-mobile.ts";
import { applyThemePresetToCSS } from "../adapters/css-vars.ts";
import type { AppId, TenantId, TenantThemeRuntime } from "../core/types.ts";
import { resolveThemeContext } from "./context.ts";
import { resolveTenantThemeDefinition } from "./resolve-definition.ts";
import { getBrandAssets } from "../../assets/tenants/index.ts";

export interface CreateTenantThemeRuntimeOptions {
  tenantId: TenantId;
  brandId?: BrandId;
  appId: AppId;
  layoutType: LayoutType;
}

export function createTenantThemeRuntime(
  options: CreateTenantThemeRuntimeOptions
): TenantThemeRuntime {
  const context = resolveThemeContext({
    tenantId: options.tenantId,
    brandId: options.brandId,
    appId: options.appId,
    layoutType: options.layoutType,
  });
  const definition = resolveTenantThemeDefinition({ context });
  const brandId = context.brandId ?? "default";

  return {
    context,
    brandId,
    definition: definition.definition,
    app: definition.app,
    brandTheme: definition.brandTheme,
    resources: definition.resources,
    brandAssets: getBrandAssets(brandId),
    antdTheme: definition.antdTheme,
    antdMobileVars: toAntdMobileTheme(definition.brandTheme),
  };
}

export function applyTenantThemeRuntime(
  runtime: TenantThemeRuntime,
  root: HTMLElement = document.documentElement
): void {
  root.dataset.tenantId = runtime.context.tenantId;
  root.dataset.brandId = runtime.brandId;
  root.dataset.appId = runtime.context.appId;
  root.dataset.layoutType = runtime.context.layoutType;
  root.dataset.themeProvider = runtime.app.provider;
  applyThemePresetToCSS(runtime, root);
}
